import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dependant"]

  connect() {
    const select = this.element.querySelector("select")
    if (select) this.toggleDependants(select.value)
  }

  change(e) {
    this.toggleDependants(e.target.value)
  }

  toggleDependants(parentValue) {
    this.dependantTargets.forEach(dependant => {
      const match = parentValue === dependant.dataset.parentValue
      dependant.style.display = match ? "revert" : "none"
    });
  }
}
